import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/stdemp/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/stdemp/labels')
  }
}



// WEBPACK FOOTER //
// ./src/api/stdemp/index.js